import type { ReactNode } from "react";
import type { GpuFreeTone } from "./gpuCapacityFormat";
import styles from "./GpuFreeToneDot.module.css";

// 여유 톤을 나타내는 채운 점이다. 색만으로는 판별할 수 없다. 그래서 옆에 라벨이나 툴팁이
// 항상 함께 있다고 전제한다. 점 자체는 보조 표현이므로 접근성 트리에서 숨긴다.
export function GpuFreeToneDot({ tone }: { tone: GpuFreeTone }): ReactNode {
  return <span className={styles.dot} data-tone={tone} aria-hidden="true" />;
}
